import {Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'app-sales-additional-information-salary',
  templateUrl: './sales-additional-information-field-salary.component.html'
})
export class SalesAdditionalInformationFieldSalaryComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() field: any;
  @Output() saveEvent = new EventEmitter();
  isSubmitted = signal(false);
  country = environment.global.country;

  ngOnInit() {
    this.form.addControl(`${this.field.key}`, new FormControl(this.field.value, [Validators.required]));
  }

  save() {
    this.isSubmitted.set(true);
    if(this.form.get(this.field.key)?.errors === null) {
      this.saveEvent.emit({id: this.field.id, value: this.form.get(this.field.key)?.value});
    }
  }

  get f() {
    return this.form.controls;
  }
}
